import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";
import { invitationToApplyForConnectOpportunityRoute } from "../invitation/route";

export const myInvitationsRoute: RouteConfig<'with-page'> = {
    name: 'My Invitations',
    path: '/work-opps/my-invitations',
    page: lazy(() => import('.')),
    context: 'member',
    flags: ['member-route'],
    permissions: ['workOps'],
    dynamicChildren: [
        invitationToApplyForConnectOpportunityRoute
    ]
}
